export enum BuildingFloorLayoutView {
  Floor = 1,
  FloorTreeMap = 2,
}
